import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'src/app/redux/createAction';
import { actionsAuth } from 'src/pages/SignInPage/_BLL/slice';
import { actionsMetaDictionaries } from 'src/pages/app/_BLL/metaDictionaries/slice';
import { ButtonPrimary } from 'src/shared/ui/_buttons/ButtonPrimary';
import { PasswordInput } from 'src/shared/ui/_inputs/PasswordInput';
import { StringInput } from 'src/shared/ui/_inputs/StringInput';
import * as Yup from 'yup';
import s from './SignInForm.module.scss';

export type SignInBody = {
	username: string;
	password: string;
};

export const SignInForm = () => {
	// * Selectors
	const authStatus = useAppSelector((state) => state.auth.status);
	const dictionariesStatus = useAppSelector((state) => state.metaDictionaries.status);

	const isLoading = authStatus === 'LOADING' || dictionariesStatus === 'LOADING';

	// * Actions
	const dispatch = useAppDispatch();
	const { signIn } = actionsAuth;
	const { getDictionaries } = actionsMetaDictionaries;

	const schema = Yup.object().shape({
		username: Yup.string().required(),
		password: Yup.string().required(),
	});

	const formMethods = useForm({
		defaultValues: {
			username: '',
			password: '',
		},
		resolver: yupResolver(schema),
		mode: 'onChange',
	});

	const { handleSubmit, control } = formMethods;

	const onSubmit = (values: SignInBody) => {
		dispatch(signIn(values))
			.unwrap()
			.then(({ token }) => dispatch(getDictionaries({ token })))
			.catch((error) => console.log(error));
	};

	// * Component
	return (
		<form
			className={s.form}
			onSubmit={handleSubmit(onSubmit)}
		>
			<div className={s.fields}>
				<Controller
					name="username"
					control={control}
					render={({ field, fieldState }) => (
						<StringInput
							{...field}
							label="User name or email"
							size="large"
							error={fieldState.error?.message}
						/>
					)}
				/>

				<Controller
					name="password"
					control={control}
					render={({ field, fieldState }) => (
						<PasswordInput
							{...field}
							label="Password"
							size="large"
							error={fieldState.error?.message}
						/>
					)}
				/>
			</div>

			<ButtonPrimary
				htmlType="submit"
				loading={isLoading}
			>
				Sign in
			</ButtonPrimary>
		</form>
	);
};
